import axios from '../axios'

const patchRescheduleApi = async (eventId, startAt, endAt, teacherId) => {
    return await axios.patch(`api/teacher/events/${eventId}/reschedule`, { start_at: startAt, end_at: endAt, teacherId: teacherId })
}

export default patchRescheduleApi